<template>
  <div>
    <div id="Minuta_div" class="w-100 px-5 py-4">
      <div id="TituloEstadisticas_div">
        <h1 style="margin-bottom: 0px;">CARPETA DIGITAL 0001/2019</h1>
        <h3 style="margin-top: 0px;">Minuta</h3>
        <button v-on:click="GetMinuta">Obtener Minuta</button>
      </div>
    </div>
    <div class="container">

    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import api from '@/../static/js/api'

  export default {
  components: {
    },
  created: function () {
    this.GetMinuta()
  },
  methods:{
    GetMinuta(){
      let p = {AudienciaId: 1, EsPrueba: true}
      var nombreArchivo = new Date().toLocaleString() + "_Minuta.docx";
      const FileDownload = require('js-file-download');
      axios.post(api.conexion + api.Forseti.sistema.Minuta, p)
         .then((response) => {
              FileDownload(response.data, nombreArchivo);
      });
    }
  }
  }

</script>



// WEBPACK FOOTER //
// src/components/Forseti/Audiencias/PanelDeAudienciasPendientes/Minuta.vue